export default "__VITE_ASSET__7fb041f6__"